import ToggleSwitchComponent from '../components/ToggleSwitch/viewer/ToggleSwitch';
import ToggleSwitchController from '../components/ToggleSwitch/viewer/ToggleSwitch.controller';


const ToggleSwitch = {
  component: ToggleSwitchComponent,
  controller: ToggleSwitchController
};


export const components = {
  ['ToggleSwitch']: ToggleSwitch
};

